import React, { Component } from "react";
import { connect } from "react-redux";
import Chatbot_Talk_To_Bot from "../../Chatbot_talk_to_bot";
import "../../chatbot.css";
import Draggable from "react-draggable";
import LoginForm from "../forms/LoginForm";
import ChatBotHeader from "./ChatBotHeader";
import { update_botStatus_inactive } from "../../../../store/actions/botStatusAction";
import SignupForm from "../forms/SignupForm";
import {
  registerServiceWorker,
  validateSessionStorageData,
} from "../../../../services/other_services";
import { initializeHandlers } from "../../../../services/socketServices.js";

class MaximizedChatbot extends Component {
  messagesEnd = "";
  constructor(props) {
    super(props);
    this.state = {};
    this.toggleChatWindowSize = this.toggleChatWindowSize.bind(this);
    this.getLoginSignUp = this.getLoginSignUp.bind(this);
    // this.initializeNewSocket = this.initializeNewSocket.bind(this);
  }

  toggleChatWindowSize() {
    let chatWindow = this.refs.maximizedChatWindow;
    if (chatWindow.style.width == "500px") {
      chatWindow.style.width = "610px";
    } else if (chatWindow.style.width == "610px") {
      chatWindow.style.width = "390px";
    } else {
      chatWindow.style.width = "500px";
    }
  }

  getLoginSignUp = () => {
    // debugger;
    //If Session Data exist in Session Storage Recover that
    let userDetails = validateSessionStorageData();
    // console.log("userDetails", userDetails);
    if (userDetails) {
      // debugger;
      initializeHandlers(userDetails);
      // registerServiceWorker(userDetails);
      //************** SET user data in store loginStatus=true **********//
      this.props.set_User_Data_After_Login({
        firstName: userDetails.fname,
        lastName: userDetails.lname,
        userType: userDetails.userType,
        username: userDetails.username,
        token: userDetails.token,
      });

      return <></>;
    }
    return (
      <div
        className={
          this.props.isOpened
            ? "effect8 z-depth-5 chatbot-Wrapper active"
            : "effect8 z-depth-5 chatbot-Wrapper"
        }
      >
        <ChatBotHeader
          update_botStatus_inactive={this.props.update_botStatus_inactive}
        />

        <div
          id="chatbot"
          className={this.props.isLogIn ? "" : "logIn_form"}
          ref="chat_box_ref"
        >
          {this.props.activeComponents.main == "SignupForm" ? (
            <SignupForm
              handleClose={() => {
                this.props.change_main_component("LoginForm");
              }}
            ></SignupForm>
          ) : (
            <LoginForm
              registerHandlers={this.props.registerHandlers}
            ></LoginForm>
          )}
        </div>
      </div>
    );
  };

  render() {
    return (
      // <Draggable
      //   disabled={this.props.videoFlo.sessionId}
      //   handle=".chatbot-header"
      //   bounds="parent"
      // >
      <div
        className={
          this.props.isOpened
            ? "maximizedChatWindow"
            : "maximizedChatWindow inactive"
        }
        ref="maximizedChatWindow"
      >
        {!this.props.isLogIn && this.getLoginSignUp()}
        {/* this.props.isLogIn && && this.initializeNewSocket() */}
        {this.props.isLogIn && (
          <>
            <div
              className={
                this.props.talk_to_what == "bot"
                  ? "effect8 z-depth-5 chatbot-Wrapper active"
                  : "effect8 z-depth-5 chatbot-Wrapper"
              }
            >
              <Chatbot_Talk_To_Bot
                toggleChatWindowSize={this.toggleChatWindowSize}
                conversationData={this.props.conversationData}
                // initializeNewSocket = {this.initializeNewSocket}
              ></Chatbot_Talk_To_Bot>
            </div>

            {/* <div
                className={
                  this.props.talk_to_what != "bot"
                    ? "effect8 z-depth-5 chatbot-Wrapper active"
                    : "effect8 z-depth-5 chatbot-Wrapper"
                }
              >
                <Chatbot_Talk_To_Human
                  toggleChatWindowSize={this.toggleChatWindowSize}
                  create_Notification={this.props.create_Notification}
                ></Chatbot_Talk_To_Human>
              </div> */}
          </>
        )}
      </div>
      // </Draggable>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    set_talk_to_what: (talk_to) => {
      dispatch({ type: "TALK_TO_WHAT_ACTION", payload: talk_to });
    },
    update_botStatus_inactive: () => {
      dispatch(update_botStatus_inactive);
    },
    change_main_component: (componentName) => {
      dispatch({ type: "CHANGE_MAIN_COMPONENT", payload: componentName });
    },
    set_User_Data_After_Login: (logInData) => {
      dispatch({ type: "LOGIN_SUCCESS_ACTION", payload: logInData });
    },
  };
};

const mapStateToProps = (state) => {
  return {
    isOpened: state.botStatus.isOpened,
    isLogIn: state.logInStatus.isLogIn,
    talk_to_what: state.talk_to_what.name,
    logInStatus: state.logInStatus,
    conversationData: state.conversationData,
    isModalOneOpen: state.modalStatus.isOpened,
    isZoomModalopen: state.zoomModalStatus.isOpened,
    videoFlo: state.videoFlo,
    activeComponents: state.activeComponents,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MaximizedChatbot);
